import { render } from "./SummaryOrdersSent.vue?vue&type=template&id=7715dd2e&scoped=true"
import script from "./SummaryOrdersSent.vue?vue&type=script&lang=js"
export * from "./SummaryOrdersSent.vue?vue&type=script&lang=js"

import "./SummaryOrdersSent.vue?vue&type=style&index=0&id=7715dd2e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7715dd2e"]])

export default __exports__